import { Converter } from '../types/converter';

export const magneticFieldStrengthConverter: Converter = {
  id: 'magneticFieldStrength',
  name: 'Magnetic Field Strength Converter',
  icon: 'Magnet',
  categories: ['magnetism'],
  units: [
    { name: 'Ampere/meter', symbol: 'A/m', factor: 1 },
    { name: 'Ampere turn/meter', symbol: 'At/m', factor: 1 },
    { name: 'Kiloampere/meter', symbol: 'kA/m', factor: 1000 },
    { name: 'Oersted', symbol: 'Oe', factor: 79.5774715459477 }
  ]
};
